import React from "react";

const CorporateGovernance = () => (
  <div
    style={{ minHeight: "100vh", background: "#050A18", padding: "0 0 48px 0" }}
  >
    <div
      style={{
        background: "#111827",
        color: "#fff",
        padding: "56px 0 36px 0",
        textAlign: "center",
      }}
    >
      <div className="text-3xl font-bold tracking-wide text-center mb-2">
        <h2>
          <span className="text-[#4FA0FF]">Corporate</span>
          <span className="text-[white] ml-1">Governance</span>
        </h2>
      </div>

      <p style={{ fontSize: "1.1rem", marginTop: 12, color: "#e0e0e0" }}>
        Reviewed by Board of Directors | Approved on 15 April 2025
      </p>
    </div>

    <div
      style={{
        maxWidth: 900,
        margin: "40px auto",
        background: "#111827",
        borderRadius: 16,
        boxShadow: "0 4px 24px 0 rgba(79, 160, 255, 0.1)",
        padding: "40px 28px",
        color: "#1D3557",
        fontSize: "1.08rem",
        lineHeight: 1.7,
        border: "1px solid gray",
      }}
    >
      <section style={{ marginBottom: 32 }}>
        <h2
          style={{
            fontSize: "1.3rem",
            fontWeight: 700,
            marginBottom: 12,
            color: "#4FA0FF",
          }}
        >
          Corporate Governance
        </h2>
        <p className="text-gray-300">
          At Kubermax, we follow a structured governance framework designed to ensure transparency, accountability, and ethical financial practices across all operations.
        </p>
        <p className="text-gray-300 mt-2">
          As a socially driven organization, our objective is to provide accessible financial assistance solutions while maintaining strong internal controls and responsible decision-making.
        </p>
      </section>

      <section style={{ marginBottom: 32 }}>
        <h2
          style={{
            fontSize: "1.3rem",
            fontWeight: 700,
            marginBottom: 12,
            color: "#4FA0FF",
          }}
        >
          Our Governance Practices Include
        </h2>
        <ul style={{ paddingLeft: 20, listStyleType: "disc" }}>
          <li className="text-gray-300" style={{ marginBottom: "8px" }}>
            <strong>Defined approval and verification processes</strong> for all applications
          </li>
          <li className="text-gray-300" style={{ marginBottom: "8px" }}>
            <strong>Maintenance of accurate records</strong> and documentation
          </li>
          <li className="text-gray-300" style={{ marginBottom: "8px" }}>
            <strong>Regular monitoring of operations</strong> to ensure process integrity
          </li>
          <li className="text-gray-300" style={{ marginBottom: "8px" }}>
            <strong>Commitment to ethical conduct</strong> and fair dealings
          </li>
        </ul>
      </section>

      <section>
        <p className="text-gray-300">
          We strive to operate in alignment with applicable provisions of the Companies Act, 2013, ensuring that all activities are carried out with discipline, fairness, and responsibility.
        </p>
        <div style={{ marginTop: "32px", paddingTop: "16px", borderTop: "1px solid rgba(75, 85, 99, 0.5)" }}>
          <p style={{ fontSize: "0.875rem", color: "#9ca3af", marginBottom: "4px" }}>
            <strong style={{ color: "#4FA0FF" }}>Place:</strong> Uttar Pradesh
          </p>
          <p style={{ fontSize: "0.875rem", color: "#9ca3af" }}>
            <strong style={{ color: "#4FA0FF" }}>Date:</strong> 03 July 2025
          </p>
        </div>
      </section>
    </div>
  </div>
);

export default CorporateGovernance;